// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainPageDash{
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100vw;
    height: 100vh;
}
.HomeDash{
    display: flex;
}

.Home_leftDash{
    flex: 1 1;
}

.Home_rightDash{
    flex: 5 1;
    overflow-x: auto !important; /* Enable horizontal scrolling */
}

.Home_right_topDash{
    
}
.sec1Dash{
    display: flex;
    background-color:#394fb7;
    width: 100%;
    height: 100%;
}
.sec1LeftDash{
    width: 50%;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    line-height: 4rem;
    padding-top: 10rem;
}
/* li>h1, h2{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
} */
.btn1Dash{
    display: flex;
    align-items: center;
    justify-content: center;
}
li> .btn1Dash{
    background-color: white;
    color: black;    
}
.sec1RightDash{
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.sec1RightDash>img{
    width: 40%;
    height: 40%;
    transform: rotate(20deg);
}
@media only screen and (max-width:900px) {
    .sec1Dash{
        display: flex;
        flex-direction: column;
        padding: 2rem 2rem;
        width: 100%;
        /* height: 100%; */
    }
    .sec1LeftDash{
        width: 100%;
        padding-top: 0rem;
        padding: 0rem 0rem;
    }
    h1{
        display: flex;
        align-items: center;
        justify-content: center     ;
        align-content: center;
    }
    .sec1RightDash{
        width: 100%;
    }
}
@media only screen and (max-width: 600px) {
    .Home_leftDash{
        display: none;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/CmsPages/Main/Main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,YAAY;IACZ,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;IACP,2BAA2B,EAAE,gCAAgC;AACjE;;AAEA;;AAEA;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;;;;GAKG;AACH;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,4BAA4B;QAC5B,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".mainPageDash{\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    width: 100vw;\n    height: 100vh;\n}\n.HomeDash{\n    display: flex;\n}\n\n.Home_leftDash{\n    flex: 1;\n}\n\n.Home_rightDash{\n    flex: 5;\n    overflow-x: auto !important; /* Enable horizontal scrolling */\n}\n\n.Home_right_topDash{\n    \n}\n.sec1Dash{\n    display: flex;\n    background-color:#394fb7;\n    width: 100%;\n    height: 100%;\n}\n.sec1LeftDash{\n    width: 50%;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    line-height: 4rem;\n    padding-top: 10rem;\n}\n/* li>h1, h2{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n} */\n.btn1Dash{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\nli> .btn1Dash{\n    background-color: white;\n    color: black;    \n}\n.sec1RightDash{\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.sec1RightDash>img{\n    width: 40%;\n    height: 40%;\n    transform: rotate(20deg);\n}\n@media only screen and (max-width:900px) {\n    .sec1Dash{\n        display: flex;\n        flex-direction: column;\n        padding: 2rem 2rem;\n        width: 100%;\n        /* height: 100%; */\n    }\n    .sec1LeftDash{\n        width: 100%;\n        padding-top: 0rem;\n        padding: 0rem 0rem;\n    }\n    h1{\n        display: flex;\n        align-items: center;\n        justify-content: center     ;\n        align-content: center;\n    }\n    .sec1RightDash{\n        width: 100%;\n    }\n}\n@media only screen and (max-width: 600px) {\n    .Home_leftDash{\n        display: none;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
